import { useNavigate } from 'react-router-dom';
import { Warehouse } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { useLocations } from '@/api/capacities';
import { MastersListSection } from '../shared/masters-list-section';
import { locationColumns } from './list-configs/location-column-definitions';

/**
 * Locations master list — a `PageHeader` over the server-paginated
 * `MastersListSection` (search + code/name/type/address/status columns). Rows
 * link to the location detail route. Read-only (W1 scope).
 */
export default function CapacityLocationsPage() {
  const navigate = useNavigate();

  return (
    <Container size="full">
      <PageHeader
        title="Locations"
        description="Warehouses and data centers where equipment and components are stored."
        style={{ marginBottom: 'var(--vn-space-4)' }}
      />

      <MastersListSection
        useList={useLocations}
        columns={locationColumns}
        getRowId={(r) => r.id}
        onRowClick={(r) => navigate(`/capacities/locations/${r.id}`)}
        searchPlaceholder="Search locations…"
        emptyIcon={<Warehouse size={24} />}
        emptyTitle="No locations found"
        errorTitle="Failed to load locations"
      />
    </Container>
  );
}
